import { CommonService } from './../services/common.service';
import { Router } from '@angular/router';
// import { MsAdalAngular6Service } from 'microsoft-adal-angular6'; // Deprecated - using MSAL v3 instead
import { AppConstant } from './../config/app.constant';
import { AppStateProvider } from './../services/app-state.provider';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Locale } from './locale.constant';
import { environment } from 'src/environments/environment';
import { MsalService, MsalBroadcastService, MSAL_GUARD_CONFIG, MsalGuardConfiguration } from '@azure/msal-angular';

declare var window: any;
@Injectable()
export class HttpInterceptorProvider implements HttpInterceptor {
  isOnline: boolean = true;
  constructor(
    private commonService: CommonService,
    private appStateSrv: AppStateProvider,
    // private adalService: MsAdalAngular6Service,
    private router: Router,
    private authService: MsalService,
  ) {
    this.appStateSrv.checkOnlineStatus().subscribe((isOnline: boolean) => {
      if (this.isOnline == false && isOnline == true) {
        this.appStateSrv.showToast(Locale.INFO.ONLINE);
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      }
      this.isOnline = isOnline;
      if (!isOnline) this.appStateSrv.showToast(Locale.ERROR.OFFLINE);
    });
  }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (!this.isOnline) {
      this.appStateSrv.showToast(Locale.ERROR.OFFLINE);
      return;
    }
    return next.handle(request).pipe(
      map((event: HttpEvent<any>) => {
        //this.closeLoader();
        //console.log('EVENT RESPONSE ', event);
        if (event instanceof HttpResponse) {
          // console.log('here')
          if (
            event.body &&
            event.body.errorMsg !== null &&
            event.body.errorMsg !== ''
          ) {
            if (!this.router.url.includes('verifyemail')) {
              //!this.router.url.includes('vmsGuest') &&
              this.appStateSrv.showToast(event.body.errorMsg);
              // console.log('here1')
            }
          }
          if (
            event.body &&
            event.body.successMsg !== null &&
            event.body.successMsg !== ''
          )
            if (!this.router.url.includes('verifyemail')) {
              this.appStateSrv.showToast(event.body.successMsg);
              // console.log('here2')
            }
        }

        // if(event.type === 0){
        return event;
        //}
      }),
      catchError((error: HttpErrorResponse, header) => {
        // console.log('ERROR RESPONSE ', error);
        switch (error.status) {
          case 400:
            if (this.ObjectSize(error.error.errors) > 0) {
              // error.error.errors.forEach(element => {
              //   this.appStateSrv.showToast(element);
              // });
              for (let [key, value] of Object.entries(error.error.errors)) {
                // console.log(key, value);
                error.error.errors[key].forEach((element) => {
                  this.appStateSrv.showToast(element);
                });
              }
            } else {
              this.appStateSrv.showToast(Locale.ERROR[400]);
            }
            break;
          case 401:
            this.appStateSrv.showToast(Locale.ERROR[401]);
            localStorage.clear();
            this.logoutFromCla();
            break;
          case 403:
            this.appStateSrv.showToast(Locale.ERROR[403]);
            localStorage.clear();
            this.logoutFromCla();
            break;
          case 409:
            this.appStateSrv.showToast(Locale.ERROR[409]);
            break;
          case 400:
            this.appStateSrv.showToast(Locale.ERROR[400]);
            localStorage.clear();
            this.logoutFromCla();
            break;
          case 404:
            this.appStateSrv.showToast(Locale.ERROR[404]);
            break;
          case 500:
            this.appStateSrv.showToast(Locale.ERROR[500]);
            break;
          case 413:
            this.appStateSrv.showToast(Locale.ERROR[413]);
            break;
          case 0:
            this.appStateSrv.showToast(Locale.ERROR.NETWORK_FAILURE);
            break;
          default:
            this.appStateSrv.showToast(Locale.ERROR.NETWORK_FAILURE);
        }
        return throwError(error.message);
      })
    );
  }
  ObjectSize(obj) {
    var size = 0,
      key;
    for (key in obj) {
      if (obj.hasOwnProperty(key)) size++;
    }
    return size;
  }

  logoutFromCla() {
    setTimeout(() => {
      this.logoutFromAd();
    }, 1000);
  }

  logoutFromAd(popup?: boolean) {
    // if (popup) {
    //   this.authService.logoutPopup({
    //     mainWindowRedirectUri: environment.domain + '/' // "http://localhost:4200/"
    //   });
    // } else {
    //   this.authService.logoutRedirect();
    // }
    window.location.href = `https://login.microsoftonline.com/common/oauth2/v2.0/logout?post_logout_redirect_uri=${encodeURI(environment.domain)}`
  }
}
